import React, { useEffect } from "react";
import WithFnModalComponent from "../FunctionModal";
import styles from "./index.module.scss";
import { CloseSvg } from "@/assets/icons";
import AllPresetPanel from "./index";
import TransitionModal from "../TransitionModal/TransitionModal";
import { useTranslation } from "react-i18next";
interface AllPresetPanelModalProps {
  open: boolean;
  close: () => void;
  afterClose: () => void;
  onSelect: () => void;
}

export default function AllPresetPanelMobileModal(
  props: AllPresetPanelModalProps
) {
  const { open, close, afterClose, onSelect } = props;
  const handleClose = () => {
    close();
    // afterClose?.();
  };
  useEffect(() => {
    if (!open && afterClose) {
      afterClose();
    }
  }, [open, afterClose]);
  const { t } = useTranslation();
  return (
    <TransitionModal
      visible={open}
      onClose={handleClose}
      title={t("recomment_modal_title")}
      dragable={true}
    >
      <AllPresetPanel showHeader={false} onSelect={onSelect} />
    </TransitionModal>
  );
}

export const AllPresetPanelMobileModalFn = WithFnModalComponent(
  AllPresetPanelMobileModal
);
